(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shipping-rates-mymara"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let shippingMessagesPromise;

    function fetchShippingMessages(url) {
      if (window.mymaraShippingMessages && Object.keys(window.mymaraShippingMessages).length) {
        return Promise.resolve(window.mymaraShippingMessages);
      }

      if (shippingMessagesPromise) {
        return shippingMessagesPromise;
      }

      shippingMessagesPromise = fetch(url, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Shipping rates fetch failed: ' + response.status);
          }

          return response.json();
        })
        .then((data) => {
          window.mymaraShippingMessages = data || {};
          return window.mymaraShippingMessages;
        });

      return shippingMessagesPromise;
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function getCountryFlag(countryCode) {
      if (!/^[A-Z]{2}$/.test(countryCode)) return '🌍';

      return countryCode
        .split('')
        .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
        .join('');
    }

    function getCountryName(countryCode, locale, fallbackName) {
      if (typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function') {
        try {
          const displayNames = new Intl.DisplayNames([locale || 'en'], { type: 'region' });
          const displayName = displayNames.of(countryCode);

          if (displayName) return displayName;
        } catch (error) {
          console.warn('Unable to resolve country name', countryCode, error);
        }
      }

      return fallbackName || countryCode;
    }

    function getNumericPrice(option) {
      return Number.parseFloat(String(option && option.price ? option.price : '').replace(',', '.'));
    }

    function getCheapestIndexes(options) {
      const paidPrices = options
        .map((option, index) => ({ index, price: getNumericPrice(option) }))
        .filter((item) => !Number.isNaN(item.price) && item.price > 0);
      const comparablePrices = paidPrices.length
        ? paidPrices
        : options
            .map((option, index) => ({ index, price: getNumericPrice(option) }))
            .filter((item) => !Number.isNaN(item.price));

      if (!comparablePrices.length) return [];

      const cheapestPrice = Math.min(...comparablePrices.map((item) => item.price));

      return comparablePrices.filter((item) => item.price === cheapestPrice).map((item) => item.index);
    }

    function getFastestIndexes(options) {
      const deliveryDays = options
        .map((option, index) => ({ index, days: getDeliveryDayValue(option) }))
        .filter((item) => item.days !== null);

      if (!deliveryDays.length) return [];

      const fastestDays = Math.min(...deliveryDays.map((item) => item.days));
      const slowestDays = Math.max(...deliveryDays.map((item) => item.days));

      if (fastestDays === slowestDays) return [];

      return deliveryDays.filter((item) => item.days === fastestDays).map((item) => item.index);
    }

    function getShortestDeliveryIndex(options) {
      const deliveryDays = options
        .map((option, index) => ({ index, days: getDeliveryDayValue(option) }))
        .filter((item) => item.days !== null);

      if (!deliveryDays.length) return null;

      const fastestDays = Math.min(...deliveryDays.map((item) => item.days));
      const fastestOption = deliveryDays.find((item) => item.days === fastestDays);

      return fastestOption ? fastestOption.index : null;
    }

    function getDirectorySummaryParts(options) {
      const cheapestIndexes = getCheapestIndexes(options);
      const shortestDeliveryIndex = getShortestDeliveryIndex(options);
      const cheapestOption = cheapestIndexes.length ? options[cheapestIndexes[0]] : null;
      const fastestOption = shortestDeliveryIndex !== null ? options[shortestDeliveryIndex] : null;

      return {
        cheapestPrice: cheapestOption ? cheapestOption.price : '',
        fastestDelivery: fastestOption ? fastestOption.delivery_days : '',
      };
    }

    function getDeliveryDayValue(option) {
      const deliveryDays = String(option && option.delivery_days ? option.delivery_days : '');
      const numbers = deliveryDays.match(/\d+/g);

      if (!numbers || !numbers.length) return null;

      return Math.min(...numbers.map((number) => Number.parseInt(number, 10)).filter((number) => !Number.isNaN(number)));
    }

    function getOptions(entry) {
      return Array.isArray(entry && entry.options) ? entry.options : [];
    }

    function translateDeliveryDays(value, locale) {
      const text = String(value || '');
      if (locale === 'et') {
        return text
          .replace(/Pickup within 1 hour/gi, 'Kättesaamine 1 tunni jooksul')
          .replace(/working days/gi, 'tööpäeva')
          .replace(/working day/gi, 'tööpäev');
      }

      if (locale === 'es') {
        return text
          .replace(/Pickup within 1 hour/gi, 'Recogida en 1 hora')
          .replace(/working days/gi, 'días laborables')
          .replace(/working day/gi, 'día laborable');
      }

      if (locale === 'de') {
        return text
          .replace(/Pickup within 1 hour/gi, 'Abholung innerhalb einer Stunde')
          .replace(/working days/gi, 'Werktage')
          .replace(/working day/gi, 'Werktag');
      }

      if (locale === 'lv') {
        return text
          .replace(/Pickup within 1 hour/gi, 'Saņemšana 1 stundas laikā')
          .replace(/working days/gi, 'darba dienas')
          .replace(/working day/gi, 'darba diena');
      }

      return text;
    }

    function translateMethodName(value, locale) {
      const text = String(value || '');
      if (locale === 'et') {
        return text
          .replace(/^Pick-up from store$/i, 'Järeletulemine poest')
          .replace(/^Standard postal service$/i, 'Tavaposti teenus')
          .replace(/^Standard Postal Service$/i, 'Tavaposti teenus')
          .replace(/parcel locker/gi, 'pakiautomaat')
          .replace(/pickup point/gi, 'väljastuspunkt')
          .replace(/kuller/gi, 'kuller');
      }

      if (locale === 'es') {
        return text
          .replace(/^Pick-up from store$/i, 'Recogida en tienda')
          .replace(/^Standard postal service$/i, 'Servicio postal estándar')
          .replace(/^Standard Postal Service$/i, 'Servicio postal estándar')
          .replace(/parcel locker/gi, 'taquilla de paquetería')
          .replace(/pickup point/gi, 'punto de recogida')
          .replace(/kuller/gi, 'mensajero');
      }

      if (locale === 'de') {
        return text
          .replace(/^Pick-up from store$/i, 'Abholung im Geschäft')
          .replace(/^Standard postal service$/i, 'Standardpostversand')
          .replace(/parcel locker/gi, 'Paketstation')
          .replace(/pickup point/gi, 'Abholstelle')
          .replace(/kuller/gi, 'Kurier');
      }

      if (locale === 'lv') {
        return text
          .replace(/^Pick-up from store$/i, 'Saņemšana veikalā')
          .replace(/^Standard postal service$/i, 'Standarta pasta pakalpojums')
          .replace(/parcel locker/gi, 'pakomāts')
          .replace(/pickup point/gi, 'saņemšanas punkts')
          .replace(/kuller/gi, 'kurjers');
      }

      return text;
    }

    function getCurrencyRate(currencyCode) {
      if (currencyCode === 'EUR') return 1;

      const rate = Number(window.Shopify && window.Shopify.currency ? window.Shopify.currency.rate : 1);
      return Number.isFinite(rate) && rate > 0 ? rate : 1;
    }

    function formatShippingPrice(price, currencyCode, currencySymbol, locale, freeLabel) {
      const amount = Number.parseFloat(String(price || '').replace(/[^\d,.-]/g, '').replace(',', '.'));
      if (Number.isNaN(amount)) return price || '';
      if (amount === 0) return freeLabel || price || '';

      const normalizedCurrencyCode = String(currencyCode || 'EUR').toUpperCase();
      const convertedAmount = amount * getCurrencyRate(normalizedCurrencyCode);

      if (typeof Intl !== 'undefined' && typeof Intl.NumberFormat === 'function') {
        try {
          return new Intl.NumberFormat(locale || 'en', {
            style: 'currency',
            currency: normalizedCurrencyCode,
            currencyDisplay: 'narrowSymbol',
          }).format(convertedAmount);
        } catch (error) {
          console.warn('Unable to format shipping rate price', error);
        }
      }

      return `${currencySymbol || normalizedCurrencyCode} ${convertedAmount.toFixed(2)}`;
    }

    class ShippingRatesMymara extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.select = this.querySelector('[data-shipping-country-select]');
        this.status = this.querySelector('[data-shipping-status]');
        this.selectedTarget = this.querySelector('[data-shipping-selected]');
        this.directoryTarget = this.querySelector('[data-shipping-directory]');
        this.missingDestinationTarget = this.querySelector('[data-shipping-missing-destination]');
        this.locale = this.dataset.locale || document.documentElement.lang || 'en';
        this.currentCountry = (this.dataset.country || '').toUpperCase();
        this.currencyCode = String(
          this.dataset.currencyCode ||
            (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
            'EUR'
        ).toUpperCase();
        this.currencySymbol = this.dataset.currencySymbol || this.currencyCode;

        this.load();
      }

      load() {
        fetchShippingMessages(this.dataset.messagesUrl)
          .then((messages) => {
            this.countries = Object.entries(messages || {})
              .filter(([countryCode, entry]) => /^[A-Z]{2}$/.test(countryCode) && getOptions(entry).length)
              .map(([countryCode, entry]) => {
                const name = getCountryName(
                  countryCode,
                  this.locale,
                  countryCode === this.currentCountry ? this.dataset.countryName : countryCode
                );

                return {
                  code: countryCode,
                  name,
                  flag: entry.flag || getCountryFlag(countryCode),
                  deliveryDays: translateDeliveryDays(entry.delivery_days || '', this.locale),
                  options: getOptions(entry).map((option) => ({
                    ...option,
                    name: translateMethodName(option.name, this.locale),
                    delivery_days: translateDeliveryDays(option.delivery_days || '', this.locale),
                  })),
                };
              })
              .sort((countryA, countryB) => countryA.name.localeCompare(countryB.name, this.locale));

            this.renderSelect();
            this.renderDirectory();
            this.selectCountry(this.resolveInitialCountry());
            this.select.addEventListener('change', () => this.selectCountry(this.select.value));
            if (this.directoryTarget) {
              this.directoryTarget.addEventListener('click', (event) => {
                const button = event.target.closest('[data-shipping-country-card]');
                if (!button) return;

                this.selectCountry(button.dataset.countryCode);
                (this.closest('.section-shipping-rates-mymara') || this).scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              });
            }
          })
          .catch((error) => {
            console.warn('Unable to load shipping rates', error);
            if (this.status) {
              this.status.textContent = this.dataset.unavailableLabel || '';
            }
          });
      }

      resolveInitialCountry() {
        const currentCountry = this.countries.find((country) => country.code === this.currentCountry);

        if (currentCountry) return currentCountry.code;
        if (this.countries[0]) return this.countries[0].code;

        return '';
      }

      renderSelect() {
        if (!this.select) return;

        this.select.innerHTML = this.countries
          .map((country) => `<option value="${escapeHtml(country.code)}">${escapeHtml(country.name)}</option>`)
          .join('');
      }

      selectCountry(countryCode) {
        const country = this.countries.find((item) => item.code === countryCode);

        if (!country) {
          this.renderUnavailable();
          return;
        }

        if (this.select) {
          this.select.value = country.code;
        }

        this.renderSelected(country);
        this.updateStatus(country);
      }

      renderUnavailable() {
        if (this.selectedTarget) {
          this.selectedTarget.innerHTML = '';
        }

        if (this.status) {
          this.status.textContent = this.dataset.unavailableLabel || '';
        }
      }

      updateStatus(country) {
        if (!this.status) return;

        const countLabel = this.getCountLabel(country.options.length);
        this.status.textContent = `${this.dataset.weShipLabel} ${country.name}: ${countLabel}.`;
      }

      getCountLabel(count) {
        const label = count === 1 ? this.dataset.optionSingular : this.dataset.optionPlural;
        return `${count} ${label}`;
      }

      renderSelected(country) {
        if (!this.selectedTarget) return;

        this.selectedTarget.innerHTML = `
          <article class="shipping-rates-mymara__selected-card">
            <div class="shipping-rates-mymara__selected-heading">
              <h3 class="h4 shipping-rates-mymara__country">
                <span class="shipping-rates-mymara__flag" aria-hidden="true">${escapeHtml(country.flag)}</span>
                <span>${escapeHtml(country.name)}</span>
              </h3>
              <span class="shipping-rates-mymara__count">${escapeHtml(this.getCountLabel(country.options.length))}</span>
            </div>
            ${this.renderOptions(country.options)}
          </article>
        `;
      }

      renderOptions(options) {
        if (!options.length) {
          return `<p>${escapeHtml(this.dataset.unavailableLabel)}</p>`;
        }

        const cheapestIndexes = options.length > 1 ? getCheapestIndexes(options) : [];
        const fastestIndexes = options.length > 1 ? getFastestIndexes(options) : [];

        return `
          <ul class="shipping-rates-mymara__options">
            ${options
              .map((option, index) => {
                const deliveryDays = option.delivery_days
                  ? `<p class="shipping-rates-mymara__time">${escapeHtml(this.dataset.deliveryTimeLabel)}: ${escapeHtml(option.delivery_days)}</p>`
                  : '';
                const badges = this.renderOptionBadges(index, cheapestIndexes, fastestIndexes);

                return `
                  <li class="shipping-rates-mymara__option">
                    <div class="shipping-rates-mymara__option-row">
                      <span class="shipping-rates-mymara__method-wrap">
                        <span class="shipping-rates-mymara__method">${escapeHtml(option.name)}</span>
                        ${badges}
                      </span>
                      <strong class="shipping-rates-mymara__price">${escapeHtml(this.normalizePrice(option.price))}</strong>
                    </div>
                    ${deliveryDays}
                  </li>
                `;
              })
              .join('')}
          </ul>
        `;
      }

      renderOptionBadges(index, cheapestIndexes, fastestIndexes) {
        const badges = [];

        if (cheapestIndexes.includes(index)) {
          badges.push(this.dataset.cheapestLabel);
        }

        if (fastestIndexes.includes(index)) {
          badges.push(this.dataset.fastestLabel);
        }

        return badges
          .map((badge) => `<span class="shipping-rates-mymara__badge">${escapeHtml(badge)}</span>`)
          .join('');
      }

      renderDirectory() {
        if (!this.directoryTarget) return;

        this.directoryTarget.innerHTML = this.countries
          .map((country) => {
            const summaryParts = getDirectorySummaryParts(country.options);
            const summaryItems = [];

            if (summaryParts.fastestDelivery) {
              summaryItems.push(summaryParts.fastestDelivery);
            } else if (country.deliveryDays) {
              summaryItems.push(country.deliveryDays);
            }

            if (summaryParts.cheapestPrice) {
              summaryItems.push(`${this.dataset.directoryFromLabel} ${this.normalizePrice(summaryParts.cheapestPrice)}`);
            }

            summaryItems.push(this.getCountLabel(country.options.length));
            const summary = summaryItems.join(' · ');

            return `
              <button class="shipping-rates-mymara__country-card" type="button" data-shipping-country-card data-country-code="${escapeHtml(country.code)}">
                <div class="shipping-rates-mymara__country-card-header">
                  <div class="shipping-rates-mymara__country-name">
                    <span class="shipping-rates-mymara__flag" aria-hidden="true">${escapeHtml(country.flag)}</span>
                    <span>${escapeHtml(country.name)}</span>
                  </div>
                  <span class="shipping-rates-mymara__count">${escapeHtml(this.dataset.viewRatesLabel)}</span>
                </div>
                <p class="shipping-rates-mymara__country-summary">${escapeHtml(summary)}</p>
              </button>
            `;
          })
          .join('');

        this.renderMissingDestinationNote();
      }

      renderMissingDestinationNote() {
        if (!this.missingDestinationTarget) return;

        this.missingDestinationTarget.innerHTML = `
          ${escapeHtml(this.dataset.missingDestinationPrefix)}
          <a href="#chat" data-open-chat>${escapeHtml(this.dataset.missingDestinationLink)}</a>.
        `;
      }

      normalizePrice(price) {
        return formatShippingPrice(price, this.currencyCode, this.currencySymbol, this.locale, this.dataset.freeLabel);
      }
    }

    if (!customElements.get('shipping-rates-mymara')) {
      customElements.define('shipping-rates-mymara', ShippingRatesMymara);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
